<template>
  <file-viewer :info="file">
    <template #default="{ open }">
      <base-attachment
        v-bind="attachmentProps"
        icon="clip-18"
        data-qa="files-name"
        :loading="loading"
        :title="caption"
        :has-error="hasError"
        :can-remove="!viewMode"
        :value="file"
        @remove="handleRemove"
        @cancel="handleCancel"
        @click="handlePreview($event, open)"
      />
    </template>
  </file-viewer>
</template>

<script>
import FileViewer from '@/components/file-viewer/file-viewer.vue';
import BaseAttachment from '@/shared/legacy/ui/base-attachment/base-attachment.vue';
import { appConfig } from '@/shared/legacy/lib/config/app-config';
import { baseUploadEmitter } from '../base-upload/base-upload-emitter';

export default {
  name: 'FileAttachment',
  components: {
    BaseAttachment,
    FileViewer
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    viewMode: Boolean,
    loading: Boolean
  },
  emits: ['remove'],
  computed: {
    attachmentProps() {
      if (!this.viewMode) {
        return {};
      }
      return {
        target: '_blank',
        href: this.file.url
      };
    },
    hasError() {
      return Boolean(this.file.error);
    },
    caption() {
      if (this.file.error) {
        return this.file.error.message?.match('Bad content type')
          ? this.$trlMessage('file.error.attach.type')
          : this.$trlMessage('file.error.attach');
      }
      return this.file.name;
    }
  },
  methods: {
    handlePreview(event, open) {
      if (this.file.url && !appConfig.get('is_mobile')) {
        event.stopImmediatePropagation();
        event.preventDefault();
        open();
      }
    },
    handleCancel(temporalId) {
      /**
       * Временно, чтобы оставить логику компонента base-upload рядом с ним и не заниматься перепрокидыванием методов.
       * Убрать во время рефакторинга на fsd
       * @see src/components/ui/base-upload/base-upload.vue
       * @duplicate frontend/src/components/hf/applicant-comment-attachments/attachments/file.vue
       */
      baseUploadEmitter.emit('cancel-upload', temporalId);
    },
    handleRemove() {
      /**
       * Временно, чтобы оставить логику компонента base-upload рядом с ним и не заниматься перепрокидыванием методов.
       * Убрать во время рефакторинга на fsd
       * @see src/components/ui/base-upload/base-upload.vue
       * @duplicate frontend/src/components/hf/applicant-comment-attachments/attachments/file.vue
       */
      baseUploadEmitter.emit('remove-file', this.file.temporalId);
      this.$emit('remove', this.file);
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
